module.exports = __webpack_public_path__ + "configuration/config_uat1.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=configuration/config_uat1.json!./src/config/config_uat1.json
// module id = 543
// module chunks = 3